import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import PopoverMobile from "./PopoverMobile";
import PopoverDesktop from "./PopoverDesktop";
import LinkList from "./LinkList";
import { overlayDirections } from "../../styles/mixins/overlays";
var propTypes = {
  arrow: PropTypes.oneOf(['top', 'topRight', 'topLeft', 'left', 'leftTop', 'leftBottom', 'bottom', 'bottomLeft', 'bottomRight', 'right', 'rightTop', 'rightBottom']),

  /** turns on styles meant for small screens */
  isMobile: PropTypes.bool,

  /** meant for `<PopoverNavigationLink>` */
  children: PropTypes.node,
  theme: PropTypes.shape({
    popover: PropTypes.oneOf(['dark'])
  })
};
var defaultProps = {
  theme: {}
};
export default function PopoverNavigation(_ref) {
  var isMobile = _ref.isMobile,
      children = _ref.children,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["isMobile", "children", "theme"]);

  var Popover = isMobile ? PopoverMobile : PopoverDesktop;
  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(Popover, props, React.createElement(LinkList, null, children)));
}
PopoverNavigation.darkTheme = {
  popover: 'dark'
};
Object.keys(overlayDirections).forEach(function (direction) {
  PopoverNavigation[direction] = direction;
});
PopoverNavigation.propTypes = propTypes;
PopoverNavigation.defaultProps = defaultProps;